<template>
  <div class="flex flex-col p-6 h-full w-full relative">
    <!-- Mouse Debug über ALLES -->

    <!-- Nachricht -->
    <div class="mb-4 max-w-4xl w-full">
      <p class="text-lg text-trader-dark-red dark:text-trader-red leading-relaxed text-center font-medium tracking-wide">
        {{ props.message }}
      </p>
    </div>

    <!-- Grid-Container -->
    <div class="flex gap-4">
      <div class="flex flex-col w-1/2 min-h-[700px] max-h-[700px]">
        <h3 class="text-xl font-semibold text-trader-text mb-2">
          Aktuelle Ansicht
        </h3>

        <PageGrid
            :editMode="false"
            :pageID="props.pageId"
            :test-page-id="props.pageId"
        />
      </div>

      <div class="flex flex-col w-1/2 min-h-[700px] max-h-[700px] relative">
        <div class="flex items-center gap-2 mb-2">
          <h3 class="text-xl font-semibold text-trader-text">
            Neue Ansicht
          </h3>
          <!-- Badge mit Anzahl - group hier für gezieltes Hover -->
          <div v-if="articleNumbersOver.length > 0" class="relative group">
            <div class="px-2.5 py-0.5 rounded-full text-xs font-medium cursor-help hover:bg-amber-100 dark:hover:bg-amber-900/30 transition-colors">
              Übrige Artikel: {{ articleNumbersOver.length }}
            </div>

            <!-- Tooltip direkt beim Badge -->
            <div class="absolute left-0 top-6 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-200 z-20 w-[300px]">
              <div class="bg-gray-50 dark:bg-gray-900 border border-gray-200 dark:border-gray-700 p-3 rounded-lg shadow-xl text-sm">
                <div class="space-y-1 mb-2">
                  <div v-for="(gruppe, index) in articleNumbersOver" :key="index"
                       class="pl-3 text-gray-600 dark:text-gray-400 text-xs">
                    {{ gruppe.articles.join(', ') }}
                  </div>
                </div>

                <!-- Hinweis zur Zwischenablage -->
                <div class="pt-2 border-t border-gray-200 dark:border-gray-700">
                  <div class="flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
                    <i class="fas fa-clipboard text-[10px]"></i>
                    <span class="text-[11px]">Diese Artikel landen in der Zwischenablage</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PageGrid
            ref="gridRef"
            :editMode="false"
            :template-id="props.pageTemplateId"
            :change-template="true"
            :test-page-id="props.pageId"
            @articleNumbersUpdate="articleNumbersOver = $event"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="js">

import PageGrid from "@/components/PageGrid/PageGrid.vue";
import {computed, ref} from "vue";
import Spacer from "@/customizations/selgros/Fieldtypes/Spacer.vue";
import MouseDebug from "@/components/MouseDebug/MouseDebug.vue";

const articleNumbersOver = ref([]);

const props = defineProps({
  pageId: {
    type: Number,
    required: true
  },
  pageTemplateId: {
    type: Number,
    required: true
  },
  message: {
    type: String,
    default: 'Compare Templates'
  }
})

</script>